export default '/build/96e30696.svg'